import BaseApiRequest from "./BaseApiRequest";
import { GET_APPLICANT_DETAILS } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetApplicationRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = GET_APPLICANT_DETAILS;

  constructor(id) {
    super();
    this.url = this.url.concat(id);
    this.url = `${this.url}?t=${new Date().getTime()}`;
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
